import React, { useState } from "react";
import { supabase } from "../../lib/supabase";
import AuthModal from "../modals/AuthModal";

export default function UserBadge({ user }) {
  const [showAuth, setShowAuth] = useState(false);

  const [signingOut, setSigningOut] = useState(false);
  const handleSignOut = async () => {
    if (!supabase) return;
    setSigningOut(true);
    try { await supabase.auth.signOut(); }
    catch (e) { console.error("[UserBadge] signOut failed:", e); }
    finally { setSigningOut(false); }
  };

  return (
    <>
      {user ? (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <a href="/account" style={{ fontSize: 8, color: "#3d5068", maxWidth: 120, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", textDecoration: "none" }}
            onMouseOver={e=>e.target.style.color="#60a5fa"}
            onMouseOut={e=>e.target.style.color="#3d5068"}>
            {user.email}
          </a>
          <button
            onClick={handleSignOut}
            title="Sign out"
            disabled={signingOut}
            style={{ background: "transparent", border: "1px solid #131924", color: "#3d5068", borderRadius: 4, padding: "2px 7px", fontSize: 8, cursor: signingOut ? "default" : "pointer", fontFamily: "inherit", opacity: signingOut ? 0.5 : 1 }}
          >
            {signingOut ? "…" : "↩"}
          </button>
        </div>
      ) : (
        <button
          onClick={() => setShowAuth(true)}
          style={{ background: "transparent", border: "1px solid #1e3d66", color: "#3b82f6", borderRadius: 4, padding: "3px 9px", fontSize: 8, cursor: "pointer", fontFamily: "'JetBrains Mono',monospace", fontWeight: 700 }}
        >
          Sign in
        </button>
      )}
      {showAuth && <AuthModal onClose={() => setShowAuth(false)} />}
    </>
  );
}
